import { useMediaQuery } from "react-responsive";
import { queries } from "consts";

import {
  useMatchingTargetsDrawerHeights
} from "modules/MatchingModule/MatchingListModule/hooks/useMatchingTargetsDrawerHeights";

export const useMatchingListModuleBottomPadding = (isDrawerOpen: boolean) => {
  const minLG = useMediaQuery({ query: queries.lg });
  const { headDrawerHeight, mainDrawerHeight } = useMatchingTargetsDrawerHeights();

  if (minLG) return 0;
  if (!isDrawerOpen) return headDrawerHeight;
  return headDrawerHeight + mainDrawerHeight;
}
